import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { useIntersectionObserver as y } from "usehooks-ts";
import "react";
import "dayjs";
import "react-i18next";
import v from "../../elements/link-wrapper/link-wrapper.js";
import "../../../contexts/global-context.js";
import "motion/react";
import "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import { Heading as I } from "../../elements/heading/heading.js";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import j from "../../elements/hero-full-width-image/hero-full-width-image.js";
import g from "../../elements/hero-full-width-video/hero-full-width-video.js";
import r from "./hero-media-block.module.less.js";
import a from "../../../animation/animation.module.less.js";
const G = ({
  eyebrow: s,
  title: d,
  text: m,
  link: o,
  mediaType: l = "image",
  imageDesktop: n,
  imageMobile: c,
  videoUrlDesktop: p,
  videoUrlMobile: h,
  index: t
}) => {
  const f = typeof t == "number" && t > 0, { isIntersecting: u, ref: N } = y({
    threshold: 0.25,
    freezeOnceVisible: !0
  }), b = [
    t === 0 ? a.fadeInDelay100 : u ? a.fadeInDelay100 : "",
    a.opacity0
  ].join(" ");
  return /* @__PURE__ */ e("section", { ref: N, className: "max-width padded-sides centered space-mb-2xl", children: /* @__PURE__ */ i("div", { className: r.innerWrapper, children: [
    /* @__PURE__ */ i("div", { className: [r.textWrapper, b].join(" "), children: [
      /* @__PURE__ */ e("div", { className: r.readabilityBackdrop }),
      s && /* @__PURE__ */ e("p", { className: [r.eyebrow, "eyebrow"].join(" "), children: s }),
      /* @__PURE__ */ e(I, { className: r.title, visualType: "h1", semanticType: f ? "h2" : "h1", children: d }),
      (m || o) && /* @__PURE__ */ i("p", { className: [r.text, "body-l mb-0"].join(" "), children: [
        m,
        " ",
        o && /* @__PURE__ */ e(v, { className: r.link, url: o.url, onPreNavigate: o.onPreNavigate, children: o.title })
      ] })
    ] }),
    l === "video" && p && /* @__PURE__ */ e(
      g,
      {
        blockIndex: t,
        enablePauseButton: !0,
        videoUrlMobile: h,
        videoUrlDesktop: p ?? ""
      }
    ),
    l === "image" && (n || c) && /* @__PURE__ */ e(j, { blockIndex: t, imageDesktop: n, imageMobile: c })
  ] }) });
};
export {
  G as default
};
